// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal__bottom[data-v-3dbbd04b]{padding:0 24px 24px 0}.modal__submit[data-v-3dbbd04b]{margin-left:auto}.modal__error-text[data-v-3dbbd04b]{max-width:100%;padding-right:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
